export default "/WebApp/dist/assets/svg/check-mark (1).svg";